// Query selectors
const announcement = document.querySelector('.announcement-bar');

// Check local storage with expiration
const hiddenData = JSON.parse(localStorage.getItem('announcement'));

if (hiddenData && hiddenData.value === 'hidden') {
  const now = Date.now();
  const timeElapsed = now - hiddenData.timestamp;
  
  if (timeElapsed < 86400000) { // 24 hours
    announcement.style.display = 'none';
  } else {
    localStorage.removeItem('announcement');
  }
}

// Handle closed announcement
function hideAnnouncement() {
  announcement.style.display = 'none';
  const data = {
    value: 'hidden',
    timestamp: Date.now()
  };
  localStorage.setItem('announcement', JSON.stringify(data));
}